import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api';

@Injectable({ providedIn: 'root' })
export class ThirdPartyAirlinesService {
  path: string = '/api';

  constructor(
    private apiService: ApiService,
  ) { }

  getAirlines(thirdPartyId: number): Observable<any[]> {
    return this.apiService.get<any[]>(`${this.path}/third_parties/${thirdPartyId}/airlines`);
  }

  airlinesSort(airlineGroups: any[]): any[] {
    return airlineGroups.sort((a: any, b: any) => {
      const nameA = a.airline.name.toLowerCase();
      const nameB = b.airline.name.toLowerCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    })
  }
}
